import styled, { css } from 'styled-components';

export const UpgradeDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`;

export const UpgradeDetailsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: ${theme.v3.border.radius.xl};
    padding: 24px; 
    background: ${theme.v3.colors.neutral[100]};
    width: 100%;   
  `}
`;

export const UpgradeDetailsTitle = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const UpgradeDetailsDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const UpgradeConfirmationHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UpgradeConfirmation = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-radius: ${theme.v3.border.radius.xl};
    gap: 24px;
    padding: 24px; 
    background: ${theme.v3.colors.neutral[100]};
    width: 100%;    
  `};
`;

export const UpgradeConfirmationDetails = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  `}
`;

export const UpgradePlanWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    padding: 24px;
    border-radius: ${theme.v3.border.radius.xl};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 16px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
      padding: 16px;
    }
  `}
`;

export const UpgradePlanName = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    margin: 0;
    padding: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const UpgradeResourcesItem = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const UpgradeCurrentPlanWrapper = styled(UpgradePlanWrapper)`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border: 1px solid ${theme.v3.colors.neutral[90]};

    ${UpgradePlanName} {
      color: ${theme.v3.colors.neutral[20]};
    }

    ${UpgradeResourcesItem} {
      color: ${theme.v3.colors.neutral[20]};
    }
  `}
`;

export const UpgradeTargetPlanWrapper = styled(UpgradePlanWrapper)`
  ${({ theme }) => css`
    position: relative;
    background: linear-gradient(
      15deg,
      ${theme.v3.colors.brand.snappyBlue['40']} 0%,
      ${theme.v3.colors.brand.snappyBlue['70']} 100%
    );
    box-shadow: 0 3px 24px 0 ${theme.v3.colors.brand.snappyBlue[50]}4d;

    ${UpgradePlanName} {
      color: ${theme.v3.colors.neutral[100]};
    }

    ${UpgradeResourcesItem} {
      color: ${theme.v3.colors.neutral[100]};
    }
  `}
`;

export const UpgradeCurrentPlanTag = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    background-color: ${theme.v3.colors.neutral[95]};
    padding: 4px 8px;
    border-radius: ${theme.v3.border.radius.sm};
    display: inline-block;
    vertical-align: middle;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.mini};
    }
  `}
`;

export const UpgradeTargetPlanTag = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    background-color: ${theme.v3.colors.neutral[98]};
    padding: 4px 8px;
    border-radius: ${theme.v3.border.radius.sm};
    display: inline-block;
    vertical-align: middle;
  `}
`;

export const UpgradeResourcesItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
`;

export const UpgradeResourcesItemValue = styled.strong`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.bold};
  `}
`;

export const UpgradeResourcesItemValueSuffix = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.regular};
  `}
`;

export const UpgradePlanSnappyHalf = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: calc(100% - 7px);
    left: 50%;
    transform: translateX(-50%);

    @media (max-width: ${theme.v3.breakpoints.md}) {
      left: 24px;
      transform: none;
      width: 80px;
    }
  `}
`;

export const UpgradePlanSnappyHalfImage = styled.img`
  width: 100%;
  height: auto;
`;

export const UpgradeFinancialSummaryTitle = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const UpgradeFinancialSummaryDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const UpgradeFinancialSummaryDetailsPlanWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const UpgradeFinancialSummaryDetailsPlanInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const UpgradeFinancialSummaryDetailsPlanInfoName = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const UpgradeFinancialSummaryDetailsPlanInfoCycle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[60]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.mini};
    }
  `}
`;

export const UpgradeFinancialSummaryDetailsCredits = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
`;

export const UpgradeFinancialSummaryDetailsCouponWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  width: 100%;
`;

export const UpgradeFinancialSummaryDetailsCouponInputWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;

    input {
      min-width: 342px;

      @media (max-width: ${theme.v3.breakpoints.md}) {
        min-width: 100%;
      }
    }
  `}
`;

export const UpgradeFinancialSummaryDetailsCouponLink = styled.a`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.gradients.blueGradient[0]};
    cursor: pointer;
    transition: .3s;

    &:hover{
      color: ${theme.v3.colors.gradients.blueGradient[0]};
      text-decoration: underline;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const UpgradeFinancialSummaryDetailsPlanPrice = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
    text-wrap-mode: nowrap;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const UpgradeFinancialSummaryTotalName = styled(UpgradeFinancialSummaryDetailsPlanInfoName)`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const UpgradeFinancialSummaryTotalPrice = styled(UpgradeFinancialSummaryDetailsPlanPrice)`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const UpgradeFinancialSummaryDetailsNextRecurringWrapper = styled(UpgradeFinancialSummaryDetailsPlanWrapper)`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[95]};
    border-radius: ${theme.v3.border.radius.xl};
    padding: 24px;
  `}
`;

export const UpgradeDetailsSeparator = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.v3.colors.neutral[80]};
`;

export const UpgradeDetailsAlert = styled.div`
  width: 100%;

  ul {
    padding: 0 0 0 30px;
    margin: 5px 0;
  }
`;

export const UpgradeDetailsTerms = styled.div``;

export const UpgradeDetailsTermsCheckboxLabel = styled.label`
  ${({ theme }) => css`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      align-items: flex-start;
    }

    button {
      padding: 1px 0 0 0;

      @media (max-width: ${theme.v3.breakpoints.md}) {
        padding: 3px 0 0 0;
      }
    }    

    label {
      width: 16px;
      height: 16px;
      border-radius: ${theme.v3.border.radius.sm};
      border: 1px solid ${theme.v3.colors.neutral[70]};

      svg {
        fill: ${theme.v3.colors.neutral[100]};
        stroke: ${theme.v3.colors.neutral[100]};
        flex: 0 0 12px;
        border-radius: ${theme.v3.border.radius.sm};
      }      
    }

    input:checked ~ label {
      background-color: ${theme.v3.colors.brand.snappyBlue['40']};
      border-color: ${theme.v3.colors.brand.snappyBlue['40']} !important;
    }    
  `}
`;

export const UpgradeDetailsTermsText = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0; 
    user-select: none;

    a {
      font-size: inherit;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }    
  `}
`;

export const UpgradeDetailsActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column-reverse;
      align-items: flex-start;
      gap: 16px;      
    }
  `}
`;
